<template>
  <div class="overview-page overview-page--enterprise">
    <section class="overview-hero overview-hero--enterprise">
      <div class="overview-hero__main">
        <span class="overview-hero__eyebrow">Enterprise Overview</span>
        <p class="overview-hero__summary">
          聚焦应用入口、订单状态、余额变化和预警信息。
        </p>
        <div class="overview-hero__meta">
          <div
            v-for="item in heroStats"
            :key="item.label"
            class="overview-hero__meta-card"
          >
            <strong>{{ item.value }}</strong>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <el-row class="row" :gutter="20">
      <el-col :span="24">
        <el-card class="row-card">
          <div slot="header" class="overview-card__header">
            <span class="title">应用桌面</span>
            <router-link
              :to="{ name: 'index' }"
              class="overview-card__link"
              >购买更多</router-link
            >
          </div>
          <div class="app-list" v-loading="appListLoading">
            <template v-if="appList && appList.length > 0">
              <div class="app-block" v-for="app in appList" :key="app.appID">
                <a v-if="app.domains" @click="handleDomain(app)">
                  <el-avatar
                    class="appLogo"
                    v-if="app.appLogo"
                    shape="square"
                    :size="80"
                    fit="fill"
                    :src="app.appLogo"
                  ></el-avatar>
                  <svg-icon
                    v-else
                    icon-class="app-default-icon"
                    class="defaultavatar appLogo"
                    shape="square"
                    :size="80"
                  ></svg-icon>
                  <span class="apptitle">{{ app.appName }}</span>
                </a>
              </div>
            </template>
            <no-data title="暂无应用" v-else></no-data>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="row" :gutter="20">
      <el-col v-permit="'EntOrder.List'" :xs="24" :sm="24" :md="8">
        <el-card class="row-card">
          <div slot="header" class="overview-card__header">
            <span class="title">企业订单</span>
            <router-link
              :to="{ name: 'myorderAll', params: { orderState: 'all' } }"
              class="overview-card__link"
              >查看更多</router-link
            >
          </div>
          <div v-loading="orderOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.newOrderNumMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月新订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.topayOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">待付款订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.todeliveryOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">待交付订单</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col v-permit="'EntOrder.List'" :xs="24" :sm="24" :md="8">
        <el-card class="row-card">
          <div slot="header" class="overview-card__header">
            <span class="title">企业金额</span>
            <router-link
              :to="{ name: 'integral' }"
              class="overview-card__link"
              >查看更多</router-link
            >
          </div>
          <div v-loading="orderOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.balance }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">余额</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.newConsumptionMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月消费</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.newTopUpMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月充值</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col v-permit="'WarningNotify.List'" :xs="24" :sm="24" :md="8">
        <el-card class="row-card">
          <div slot="header" class="overview-card__header">
            <span class="title">预警信息</span>
            <router-link
              :to="{ name: 'warningAlls' }"
              class="overview-card__link"
              >查看更多</router-link
            >
          </div>
          <div>
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-red">
                    {{ messageOverview.countNew }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">新预警</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ messageOverview.countFinish }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">已处理</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <MerchantsInfo
      v-if="isShowMerchantsInfo"
      @handleClose="
        isShowMerchantsInfo = false;
        appDetail = {};
      "
      :dialogVisible="isShowMerchantsInfo"
      :marketInfo="appDetail"
    />
  </div>
</template>

<script>
import { getOverviewAppList } from '@/api/delivery';
import { getOverviewAboutEnterpriseOrder } from '@/api/myOrder';
import { getOverviewAboutMessage } from '@/api/message';
import { errorHandle } from '@/utils/error';
import MerchantsInfo from '@/components/Dialog/MerchantsInfo/index.vue';
import { havePerm } from '@/utils/auth';
export default {
  name: 'Enterprise',
  components: {
    MerchantsInfo
  },
  data() {
    return {
      appDetail: {},
      isShowMerchantsInfo: false,
      appListLoading: true,
      appList: [],
      messageOverviewLoading: true,
      messageOverview: {
        countNew: 0,
        countFinish: 0
      },
      orderOverview: {
        newOrderNumMonth: 0,
        topayOrderNum: 0,
        todeliveryOrderNum: 0,
        newConsumptionMonth: 0,
        newTopUpMonth: 0,
        balance: 0
      },
      orderOverviewLoading: true,
      deliveryOverview: {
        regionNum: 0,
        runningDeliveryAppNum: 0,
        deliveryAppNumMonth: 0
      },
      deliveryOverviewLoading: true
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    heroStats() {
      return [
        {
          label: '应用数量',
          value: this.displayValue(this.appList.length)
        },
        {
          label: '月新订单',
          value: havePerm('EntOrder.List')
            ? this.displayValue(this.orderOverview.newOrderNumMonth)
            : '--'
        },
        {
          label: '当前余额',
          value: havePerm('EntOrder.List')
            ? this.displayValue(this.orderOverview.balance)
            : '--'
        },
        {
          label: '新预警',
          value: havePerm('WarningNotify.List')
            ? this.displayValue(this.messageOverview.countNew)
            : '--'
        }
      ];
    }
  },
  created() {
    this.getAppOverview();
    if (havePerm('EntOrder.List')) {
      this.getEnterpriseOrderOverview();
    }
    if (havePerm('WarningNotify.List')) {
      this.getMessageOverview();
    }
  },
  methods: {
    displayValue(value) {
      return value === 0 ? 0 : value || '--';
    },
    handleDomain(app) {
      if (app.canVisit) {
        window.open(app.domains[0], '_blank');
      } else {
        this.appDetail = app;
        this.isShowMerchantsInfo = true;
      }
    },
    getAppOverview() {
      getOverviewAppList({ marketID: this.marketID })
        .then((re) => {
          this.appList = re.apps;
          this.appListLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.appListLoading = false;
        });
    },
    getEnterpriseOrderOverview() {
      getOverviewAboutEnterpriseOrder({ marketID: this.marketID })
        .then((re) => {
          this.orderOverview = re;
          this.orderOverviewLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.orderOverviewLoading = false;
        });
    },
    getMessageOverview() {
      getOverviewAboutMessage()
        .then((re) => {
          this.messageOverview = re;
          this.messageOverviewLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.messageOverviewLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/styles/overview-dashboard.scss';
</style>



// WEBPACK FOOTER //
// src/views/overview/components/enterprise.vue